import { Link } from "react-router-dom";

interface ServiceCardProps {
  image: string;
  title: string;
  href: string;
  alt: string;
}

export default function ServiceCard({
  image,
  title,
  href,
  alt,
}: ServiceCardProps) {
  return (
    <Link
      to={href}
      className="group block bg-white border border-gray-200"
    >
      <div className="overflow-hidden">
        <img
          src={image}
          alt={alt}
          className="w-full h-auto object-cover"
        />
      </div>
      <div className="p-3 text-center">
        <h4 className="text-[#1e2a5e] font-bold text-sm leading-tight uppercase">
          {title}
        </h4>
      </div>
    </Link>
  );
}